// src/constants/sidebarItems.js
import {
    Dashboard,
    People,
    WorkspacePremium,
    Work,
    ContactMail,
    Settings as SettingsIcon,
    AdminPanelSettings,
    Person,
    Home,
    Article,
    HomeWork,
    RateReview,
} from "@mui/icons-material";

export const sidebarItems = [
    {
        key: 'dashboard',
        label: { en: 'Dashboard', ar: 'لوحة التحكم' },
        path: '/dashboard',
        icon: Dashboard,
    },
    {
        key: 'home-header',
        label: { en: 'Home Header', ar: 'رأس الصفحة الرئيسية' },
        path: '/home-header/section',
        icon: Home,
    },
    {
        key: 'about',
        label: { en: 'About', ar: 'من نحن' },
        icon: HomeWork,
        children: [
            {
                key: 'about-us',
                label: { en: 'About Us', ar: 'من نحن' },
                path: '/about',
                icon: HomeWork,
            },
            {
                key: 'about-header',
                label: { en: 'About Header', ar: 'رأس صفحة من نحن' },
                path: '/about-header/section',
                icon: Article,
            },
        ],
    },
    {
        key: 'services',
        label: { en: 'Services', ar: 'الخدمات' },
        icon: Work,
        children: [
            {
                key: 'services-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/services/section',
                icon: SettingsIcon,
            },
            {
                key: 'services-list',
                label: { en: 'All Services', ar: 'جميع الخدمات' },
                path: '/services',
                icon: Work,
            },
        ],
    },
    {
        key: 'projects',
        label: { en: 'Projects', ar: 'المشاريع' },
        icon: Work,
        children: [
            {
                key: 'projects-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/projects/section',
                icon: SettingsIcon,
            },
            {
                key: 'projects-list',
                label: { en: 'All Projects', ar: 'جميع المشاريع' },
                path: '/projects',
                icon: Work,
            },
        ],
    },
    {
        key: 'why-choose-us',
        label: { en: 'Why Choose Us', ar: 'لماذا نحن' },
        icon: WorkspacePremium,
        children: [
            {
                key: 'why-choose-us-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/why-choose-us/section',
                icon: SettingsIcon,
            },
            {
                key: 'why-choose-us-list',
                label: { en: 'All Items', ar: 'جميع العناصر' },
                path: '/why-choose-us',
                icon: WorkspacePremium,
            },
        ],
    },
    {
        key: 'testimonials',
        label: { en: 'Testimonials', ar: 'الشهادات' },
        icon: RateReview,
        children: [
            {
                key: 'testimonials-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/testimonials/section',
                icon: Article,
            },
            {
                key: 'testimonials-list',
                label: { en: 'All Testimonials', ar: 'جميع الشهادات' },
                path: '/testimonials',
                icon: RateReview,
            },
        ],
    },
    {
        key: 'clients',
        label: { en: 'Clients', ar: 'العملاء' },
        path: '/clients',
        icon: WorkspacePremium,
    },
    {
        key: 'blog',
        label: { en: 'Blog', ar: 'المدونة' },
        icon: Article,
        children: [
            {
                key: 'blog-section',
                label: { en: 'Section Data', ar: 'البيانات العامة' },
                path: '/blog/section',
                icon: SettingsIcon,
            },
            {
                key: 'blog-categories',
                label: { en: 'Categories', ar: 'التصنيفات' },
                path: '/blog/categories',
                icon: Article,
            },
            {
                key: 'blog-tags',
                label: { en: 'Tags', ar: 'الوسوم' },
                path: '/blog/tags',
                icon: Article,
            },
            {
                key: 'blog-posts',
                label: { en: 'Posts', ar: 'المقالات' },
                path: '/blog',
                icon: Article,
            },
        ],
    },
    {
        key: 'ugc',
        label: { en: 'UGC', ar: 'المحتوى المولد' },
        path: '/ugc/section',
        icon: Article,
    },
    {
        key: 'contacts',
        label: { en: 'Contacts', ar: 'رسائل التواصل' },
        icon: ContactMail,
        children: [
            {
                key: 'contacts-section',
                label: { en: 'Page Settings', ar: 'إعدادات الصفحة' },
                path: '/contacts/section',
                icon: SettingsIcon,
            },
            // {
            //     key: 'contacts-list',
            //     label: { en: 'Messages', ar: 'الرسائل' },
            //     path: '/contacts',
            //     icon: ContactMail,
            // },
        ],
    },
    {
        key: 'users',
        label: { en: 'Users', ar: 'المستخدمين' },
        path: '/users',
        icon: People,
    },
    {
        key: 'settings',
        label: { en: 'Settings', ar: 'الإعدادات' },
        icon: SettingsIcon,
        children: [
            {
                key: 'settings-general',
                label: { en: 'General', ar: 'عامة' },
                path: '/settings/general',
                icon: SettingsIcon,
            },
            {
                key: 'settings-roles',
                label: { en: 'Roles & Permissions', ar: 'الصلاحيات' },
                path: '/settings/roles',
                icon: AdminPanelSettings,
            },
            {
                key: 'settings-contact',
                label: { en: 'Contact Info', ar: 'معلومات التواصل' },
                path: '/settings/contact',
                icon: ContactMail,
            },
        ],
    },
    {
        key: 'profile',
        label: { en: 'Profile', ar: 'الملف الشخصي' },
        path: '/profile',
        icon: Person,
    },
];
